import keyMirror from 'keymirror';

export default keyMirror({
  SET_EMAIL: null,
  SEND_EMAIL: null,
  EMAIL_SENT: null,
  INVALID_EMAIL: null,
  EMAIL_SENT_ERROR: null
});
